// @ts-nocheck
import React, { useState, useEffect, useRef } from 'react';

const PRESET_COLORS = [
  // Reds
  '#FF0000', '#FF3333', '#FF6666', '#FF9999', '#FFCCCC', 
  '#CC0000', '#990000', '#660000', '#330000',
  // Oranges
  '#FF6600', '#FF8533', '#FFA366', '#FFC299', '#FFE0CC',
  // Yellows
  '#FFCC00', '#FFD633', '#FFE066', '#FFEB99', '#FFF5CC', 
  // Greens
  '#00CC00', '#33CC33', '#66CC66', '#99CC99', '#CCFFCC',
  '#006600', '#003300',
  // Blues
  '#0066CC', '#3385D6', '#66A3E0', '#99C2EB', '#CCE0F5',
  '#003366', '#002244',
  // Purples
  '#6600CC', '#7F33CC', '#9966CC', '#B299D6', '#D9CCEB',
  // Grays
  '#333333', '#666666', '#999999', '#CCCCCC', '#EEEEEE',
];

const ColorPickerModal = ({ isOpen, onClose, initialColor, onColorSelect }) => {
  const [selectedColor, setSelectedColor] = useState(initialColor || '#000000');
  const [customColor, setCustomColor] = useState(initialColor || '#000000');
  const modalRef = useRef();

  // Reset the selected color when opening the modal
  useEffect(() => {
    if (isOpen) {
      setSelectedColor(initialColor || '#000000');
      setCustomColor(initialColor || '#000000');
    }
  }, [isOpen, initialColor]);

  // Handle clicks outside the modal to close it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handlePresetColorClick = (color) => {
    setSelectedColor(color);
    setCustomColor(color);
  };

  const handleCustomColorChange = (e) => {
    setCustomColor(e.target.value);
    setSelectedColor(e.target.value);
  };

  const handleSave = () => {
    onColorSelect(selectedColor);
    onClose();
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div 
        ref={modalRef}
        className="bg-white rounded-lg shadow-xl p-6 w-[400px] max-w-[90vw]"
      >
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold text-gray-800">Select Color</h3>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Color preview */}
        <div className="mb-4">
          <div 
            className="h-12 w-full rounded-md border border-gray-300" 
            style={{ backgroundColor: selectedColor }}
          />
        </div>

        {/* Preset colors */}
        <div className="mb-4">
          <h4 className="text-sm font-medium text-gray-700 mb-2">Preset Colors</h4>
          <div className="grid grid-cols-8 gap-2">
            {PRESET_COLORS.map((color) => (
              <button
                key={color}
                onClick={() => handlePresetColorClick(color)}
                className={`h-8 w-8 rounded-full border ${
                  selectedColor === color 
                    ? 'border-2 border-blue-500 shadow-sm' 
                    : 'border-gray-300'
                }`}
                style={{ backgroundColor: color }}
                aria-label={`Select color ${color}`}
              />
            ))}
          </div>
        </div>

        {/* Custom color input */}
        <div className="mb-4">
          <h4 className="text-sm font-medium text-gray-700 mb-2">Custom Color</h4>
          <div className="flex items-center">
            <input
              type="text"
              value={customColor}
              onChange={handleCustomColorChange}
              className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="#000000"
            />
            <div 
              className="ml-2 h-9 w-9 rounded-md border border-gray-300" 
              style={{ backgroundColor: customColor }}
            />
          </div>
        </div>

        {/* Action buttons */}
        <div className="flex justify-end space-x-2">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default ColorPickerModal;